import { useMemo } from 'react';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import { useMacroByEnvironment } from '../discovery/macro';
import { useEnvironmentScope } from '../useEnvironmentScope';

export const useMacro = (
  uniqueId: ParsedUniqueId | undefined,
  environmentId?: number,
) => {
  const { environmentId: inheritedEnvironmentId } = useDbtCloudProject();
  const validEnvironmentId = environmentId ?? inheritedEnvironmentId;
  const { userId } = useEnvironmentScope();

  const [{ fetching, error, data }] = useMacroByEnvironment({
    environmentId: validEnvironmentId,
    userId: userId as number | null,
    uniqueId: uniqueId?.raw ?? '',
    pause: uniqueId?.resourceType !== 'macro' || userId === 'loading',
  });

  const macroQuery = useMemo(() => {
    const definitionEdge = data?.environment.definition?.macros.edges?.[0];
    return {
      fetching,
      error,
      data: { definition: definitionEdge?.node },
    };
  }, [fetching, error, data]);

  return macroQuery;
};
